import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";

export default function FilterModal({
  show,
  onHide,
  filters,
  onApplyFilters,
  onClearFilters,
}) {
  const [tempFilters, setTempFilters] = useState({
    company: "",
    purchasedFrom: "",
    purchaseMonth: "",
  });

  const [companyOptions, setCompanyOptions] = useState([]);
  const [purchasedFromOptions, setPurchasedFromOptions] = useState([]);

  // =====================================================
  // LOAD CURRENT FILTERS WHEN MODAL OPENS
  // =====================================================

  useEffect(() => {
    if (show) {
      setTempFilters({
        company: filters?.company || "",
        purchasedFrom: filters?.purchasedFrom || "",
        purchaseMonth: filters?.purchaseMonth || "",
      });
    }
  }, [show, filters]);

  // =====================================================
  // FETCH FILTER OPTIONS
  // =====================================================

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/asset-types/filter-options`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data?.success) {
          setCompanyOptions(response.data.companies || []);
          setPurchasedFromOptions(response.data.purchasedFrom || []);
        }
      } catch (error) {
        console.error(
          "Error fetching asset type filter options:",
          error.response?.data || error,
        );
      }
    };

    if (show) {
      fetchFilterOptions();
    }
  }, [show]);

  // =====================================================
  // APPLY FILTERS
  // =====================================================

  const handleApply = () => {
    if (onApplyFilters) {
      onApplyFilters(tempFilters);
    }

    onHide();
  };

  // =====================================================
  // REMOVE FILTERS
  // =====================================================

  const handleRemove = () => {
    const clearedFilters = {
      company: "",
      purchasedFrom: "",
      purchaseMonth: "",
    };

    setTempFilters(clearedFilters);

    if (onClearFilters) {
      onClearFilters(clearedFilters);
    }

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Asset Type Filters</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* =====================================================
              COMPANY
          ====================================================== */}

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Company</b>
            </Form.Label>

            <Select
              options={companyOptions}
              placeholder="Select Company"
              isClearable
              value={
                tempFilters.company
                  ? {
                      value: tempFilters.company,
                      label: tempFilters.company,
                    }
                  : null
              }
              onChange={(option) => {
                setTempFilters((prev) => ({
                  ...prev,
                  company: option?.value || "",
                }));
              }}
            />
          </Form.Group>

          {/* =====================================================
              PURCHASED FROM
          ====================================================== */}

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Purchased From</b>
            </Form.Label>

            <Select
              options={purchasedFromOptions}
              placeholder="Select Purchased From"
              isClearable
              value={
                tempFilters.purchasedFrom
                  ? {
                      value: tempFilters.purchasedFrom,
                      label: tempFilters.purchasedFrom,
                    }
                  : null
              }
              onChange={(option) => {
                setTempFilters((prev) => ({
                  ...prev,
                  purchasedFrom: option?.value || "",
                }));
              }}
            />
          </Form.Group>

          {/* =====================================================
              PURCHASE MONTH
          ====================================================== */}

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Purchase Month</b>
            </Form.Label>

            <Form.Control
              type="month"
              value={tempFilters.purchaseMonth}
              onChange={(e) => {
                setTempFilters((prev) => ({
                  ...prev,
                  purchaseMonth: e.target.value,
                }));
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemove}>
          Remove Filters
        </Button>

        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
